<template>
  <!-- @mouseover="(e) => elHover(e, { elementID: detail.id, lv: dt.lv })"
    @mouseleave="(e) => elHover(e, { elementID: undefined })"
    @click="(e) => elActive(e, { elementID: detail.id, lv: dt.lv })" -->
  <Wrapper
    v-if="isOverlay"
    @mouseover="hover"
    @mouseleave="leave"
    @click="click"
    :style="`cursor: ${sectionActive.id == detail.id[detail.id.length - 1] ? 'auto' : 'pointer'};`"
  >
    <!-- <SectionName class="text-center lbl-name" :lv="dt.lv">{{
      lblName
    }}</SectionName> -->
    <template v-if="showTool">
      <!-- <SectionTool
        v-if="is_active"
        class="d-flex align-items-center section-tool"
      >
        <div
          class="text-center"
          v-show="!isSectionPage"
          @click.stop.prevent="duplicateSection()"
          v-b-tooltip.hover
          title="duplicate section"
        >
          <i
            class="far fa-clone mb-2"
            style="vertical-align: -webkit-baseline-middle"
          ></i>
        </div>
        <div
          class="text-center"
          v-show="isShowUp"
          @click.stop.prevent="moveSectionUp()"
          v-b-tooltip.hover
          title="up section"
        >
          <i
            class="mt-1 far fa-arrow-up"
            style="vertical-align: -webkit-baseline-middle"
          ></i>
        </div>
        <div
          class="text-center"
          v-show="isShowDown"
          @click.stop.prevent="moveSectioDown()"
          v-b-tooltip.hover
          title="down section"
        >
          <i
            class="mt-1 far fa-arrow-down"
            style="vertical-align: -webkit-baseline-middle"
          ></i>
        </div>
        <div
          class="text-center"
          v-show="!isSectionPage"
          v-b-tooltip.hover
          @click.stop.prevent="removeSection()"
          title="remove section"
        >
          <i
            class="far fa-trash-alt mt-1"
            style="vertical-align: -webkit-baseline-middle"
          ></i>
        </div>
      </SectionTool> -->

      <!-- <AddSection class="add-section top">
        <div @click.stop.prevent="addSection('up')" class="icon-hover-label">
          <span class="text-white center-hv icon-wrapper">
            <i class="fas fa-plus"></i>
          </span>
          <span class="icon-label">
              Add Section
          </span>
        </div>
      </AddSection>

      <AddSection
        class="add-section bottom"
      >
        <div @click.stop.prevent="addSection('down')" class="icon-hover-label">
          <span class="text-white icon-wrapper">
            <i class="fas fa-plus"></i>
          </span>
          <span class="icon-label">
              Add Section
          </span>
        </div>
      </AddSection> -->
    </template>

    <!-- <Overlay class="overlay" :active="is_active"></Overlay> -->
  </Wrapper>
</template>

<script>
import { SECTION_TYPE_NONE_SETTING } from "@model/components/componentMeta.model";
import { mapGetters } from "vuex";
import {
  // Overlay,
  Wrapper,
  // SectionName,
  // SectionTool,
  // AddSection,
} from "./Overlay.styled";

export default {
  components: {
    Wrapper,
    // SectionName,
    // Overlay,
    // SectionTool,
    // AddSection,
  },
  computed: {
    ...mapGetters({
      elHoverID: "designIframe/component/elHoverID",
      elActiveID: "designIframe/component/elActiveID",
      components: "designIframe/metadata/components",
      elActiveParentID: "designIframe/component/elActiveParentID",
      widgetActive: "designIframe/frame/widgetActive",
      sectionHover: "designIframe/frame/sectionHover",
      slideSectionHover: "designIframe/frame/slideSectionHover",
      sectionActive: "designIframe/frame/sectionActive",
      CONTENT_CONTAINER: "designIframe/metadata/CONTENT_CONTAINER",
    }),
    showTool() {
      return (
        this.dt.lv === 0 &&
        this.detail.id !== "header" &&
        this.detail.id !== "footer" &&
        this.detail.id[0] &&
        this.detail.id[0] !== "cell" &&
        this.sectionActive.id &&
        this.elActiveID &&
        this.elActiveID[1] &&
        this.sectionActive.id == this.elActiveID[1] &&
        this.elActiveID[1].startsWith("sec")
      );
    },
    is_hover() {
      if (Array.isArray(this.detail.id)) {
        return this.elHoverID.indexOf(this.detail.id.slice(-1)[0]) > -1;
      } else {
        return this.elHoverID.indexOf(this.detail.id) > -1;
      }
    },
    is_active() {
      if (Array.isArray(this.detail.id)) {
        return this.elActiveParentID.indexOf(this.detail.id.slice(-1)[0]) > -1;
      } else {
        return this.elActiveParentID.indexOf(this.detail.id) > -1;
      }
    },
    is_focus() {
      if (Array.isArray(this.detail.id)) {
        return (
          this.elActiveParentID[this.elActiveParentID.length - 1] ==
          this.detail.id[this.detail.id.length - 1]
        );
      } else {
        return (
          this.elActiveParentID[this.elActiveParentID.length - 1] ==
          this.detail.id
        );
      }
    },
    lblName() {
      return this.detail.name
        ? this.components[this.detail.name]
          ? this.components[this.detail.name].properties.name
          : this.detail.name.toUpperCase()
        : "error";
    },
    dt() {
      return {
        name: "",
        id: undefined,
        lv: 0,
        ...this.detail,
      };
    },
    indexSection() {
      return this.CONTENT_CONTAINER.componentsID.indexOf(this.sectionActive.id);
    },
    isSectionPage() {
      return this.sectionActive.id === "SECTION_PAGE";
    },
    isPageSystem() {
      const index = this.CONTENT_CONTAINER.componentsID.indexOf("SECTION_PAGE");
      return index >= 0;
    },
    // isSystemWidget() {
    //   return this.sectionActive.id === "SECTION_PAGE";
    // },
    isFirstIndex() {
      return this.indexSection == 0;
    },
    isLastIndex() {
      return (
        this.CONTENT_CONTAINER.componentsID.length - 1 == this.indexSection
      );
    },
    isBeforeLastIndex() {
      return (
        this.CONTENT_CONTAINER.componentsID.length - 2 == this.indexSection
      );
    },
    isShowDown() {
      let show = true;
      if (this.isSectionPage) {
        show = false;
      } else {
        if (this.isBeforeLastIndex && this.isPageSystem) {
          show = false;
        } else {
          show = true;
          if (this.isLastIndex) {
            show = false;
          }
        }
      }
      return show;
    },
    isShowUp() {
      let show = true;
      if (this.isSectionPage) {
        show = false;
      } else {
        if (this.isFirstIndex) {
          show = false;
        } else {
          show = true;
        }
      }
      return show;
    },
    isSectionType() {
      return this.components.SECTION_PAGE.type;
    },
  },
  watch: {
    is_active(next) {
      if (!next) {
        this.$store.dispatch("designIframe/texteditor/clearTextEditor");
      }
    },
  },
  methods: {
    duplicateSection() {
      this.$store.commit("designIframe/setStatePath", {
        value: {
          sectionID: this.detail.id[this.detail.id.length - 1],
        },
        path: "/component/addComponent/section",
      });
      this.$store.dispatch("designIframe/component/duplicateSection", {
        component_id: this.detail.id[this.detail.id.length - 1],
      });

      this.$store.dispatch("designIframe/snapshot/genSnapshot");
    },
    moveSectionUp() {
      this.$store.dispatch("designIframe/component/moveSectionUp", {
        id: this.detail.id[this.detail.id.length - 1],
      });
    },
    moveSectioDown() {
      this.$store.dispatch("designIframe/component/moveSectionDown", {
        id: this.detail.id[this.detail.id.length - 1],
      });
    },
    addSection(direction) {
      this.$store.commit("designIframe/setStatePath", {
        value: {
          sectionID: this.detail.id[this.detail.id.length - 1],
          direction,
        },
        path: "/component/addComponent/section",
      });
      this.$store.dispatch("design/setMode", {
        mode: "add_section",
      });
    },
    removeSection() {
      this.$store.dispatch("designIframe/component/removeSection", {
        id: this.detail.id[this.detail.id.length - 1],
      });
    },

    leave() {
      if (this.detail.id[1] === this.sectionHover.id || this.detail.id[1] === this.slideSectionHover.id) return
      this.$store.dispatch("designIframe/frame/setSectionHover", {});
      this.$store.dispatch("designIframe/frame/setSlideSectionHover", {});
    },
    hover(e) {
      e.stopPropagation();
      var compID = this.detail.id[1];

      this.$store.dispatch("designIframe/frame/setSectionHover", {
        component_id: compID,
        name: this.detail.name,
      });
      this.$store.dispatch("designIframe/frame/setFloatFrameHover", {});
    },
    click(e) {
      e.stopPropagation();
      var compID = this.detail.id[1];
      this.$store.dispatch("design/setMode", {});

      this.$store.dispatch("designIframe/frame/setSectionActive", {
        component_id: compID,
        name: this.detail.name,
      });
      this.$store.dispatch("designIframe/frame/setSlideSectionActive", {});
      this.$store.dispatch("designIframe/frame/setSlideContainerActive", {});
      this.$store.dispatch("designIframe/frame/setSlideSectionHover", {});
      this.$store.dispatch("designIframe/frame/setSlideContainerHover", {});
      this.$store.dispatch("designIframe/frame/setCellActive", {});
      this.$store.dispatch("designIframe/frame/setCellHover", {});
      this.$store.dispatch("designIframe/frame/setWidgetActive", {});
      this.$store.dispatch("designIframe/frame/setWidgetHover", {});
      this.$store.dispatch("designIframe/frame/setFloatFrameActive", {});
      this.$store.dispatch("designIframe/frame/setFloatFrameHover", {});
      this.$store.dispatch("designIframe/frame/setParentWidgetActive", {});
      let noneSetting = false;
      SECTION_TYPE_NONE_SETTING.find((type) => {
        Object.entries(this.components).forEach((item) => {
          if (type === item[1].type && item[1].id === compID) {
            noneSetting = true;
          }
        });
      });
      if (noneSetting) {
        this.$store.dispatch("design/component/elActive", {});
      } else {
        this.$store.dispatch("design/component/elActive", {
          elementID: ["component", compID],
        });
      }
    },
  },
  props: {
    isOverlay: {
      type: Boolean,
      default() {
        return false;
      },
    },
    textEditor: {
      type: Object,
    },
    modalId: {
      type: Object,
    },
    detail: {
      type: Object,
    },
    slideSectionIndex: {
      type: Number,
      default() {
        return null
      }
    }
  },
};
</script>

<style lang="scss">
  .icon-hover-label {
    position: relative;
    display: inline-block;
    white-space: nowrap;
    outline: none;
    transition: all 0.45s cubic-bezier(0.65, 0, 0.076, 1);
    .icon-label {
      // position: absolute;
      // top: 0px;
      // left: 35%;
      white-space: nowrap;
      pointer-events: none;
      // width: 40px;
      opacity: 0;
      transition: all 0.45s cubic-bezier(0.65, 0, 0.076, 1);
    }
    &:hover {
      border-radius: 20px;
      width: 100%;
      .icon-wrapper {
        left: 20%;
      }
      .icon-label {
        opacity: 1;
        position: static;
      }
    }
  }
</style>